
import{Link,useLocation}from"react-router-dom"

interface P{user:any}

export function MobileNav({user}:P){
const{pathname}=useLocation()
const isA=(to:string)=>pathname===to||pathname.startsWith(to+"/")

const items=[
  {to:"/feed",d:"M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z",l:"Home"},
  {to:"/trending",d:"M13 7h8m0 0v8m0-8l-8 8-4-4-6 6",l:"Hot"},
  {to:"/post/create",d:"M12 4v16m8-8H4",l:"Post",create:true},
  {to:"/search",d:"M21 21l-4.35-4.35M17 11A6 6 0 105 11a6 6 0 0012 0z",l:"Search"},
  ...(user?[{to:`/profile/${user.username}`,d:"M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z",l:"Me"}]:[{to:"/auth/login",d:"M11 16l-4-4m0 0l4-4m-4 4h14",l:"Log In"}]),
]

return(
<nav className="mobile-nav lg:hidden">
  <div className="flex items-center justify-around h-full px-1 max-w-sm mx-auto">
    {items.map(({to,d,l,create})=>{
      const active=isA(to)
      return(
      <Link key={to} to={to}
        className="flex flex-col items-center gap-0.5 px-2 py-1 rounded-lg transition-colors relative"
        style={{color:create?"var(--brand)":active?"var(--text)":"var(--text3)"}}>
        <div className={active&&!create?"notif-dot relative":""}>
          <svg className={create?"w-7 h-7":"w-5 h-5"} fill={create?"var(--brand)":"none"} viewBox="0 0 24 24"
            stroke={create?"#0a0a0a":"currentColor"} strokeWidth={active?2.5:2}>
            <path strokeLinecap="round" strokeLinejoin="round" d={d}/>
          </svg>
        </div>
        <span className="text-[9px] font-bold uppercase tracking-wide">{l}</span>
      </Link>
    )})}
  </div>
</nav>
);}
